module.exports = __webpack_public_path__ + "img/ts23.3ff30aa9.png";